import React, { useRef, useMemo } from 'react';
import { useTypingAnimation } from '../hooks/useTypingAnimation';
import { useScrollReveal } from '../hooks/useScrollReveal';
import '../styles/contact.css';

function Contact() {
  const ref = useRef(null);
  useScrollReveal(ref);

  const sentences = useMemo(() => [
    "Creating incorruptible financial machines.",
    "Serving people for a fairer world."
  ], []);

  const { typedText, currentColor } = useTypingAnimation(sentences);

  const handleEmailClick = (e) => {
    e.preventDefault();
    const email = 'info@quantena.tech';
    const subject = 'Contact from Website';
    const body = 'Hello Quantena,';

    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
      '_blank'
    );

    navigator.clipboard.writeText(email).then(() => {
      alert(`Email address ${email} copied to clipboard. Please use this to contact us if your email client didn't open.`);
    }).catch(() => {
      alert(`Please email us at ${email}`);
    });
  };

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="contact" ref={ref}>
      <div className="contact-glow" />
      <div className="contact-label-row reveal">
        <span className="contact-label-tag">Get in touch</span>
      </div>
      <div className="contact-typing reveal">
        <p className="contact-typing-text" style={{ color: currentColor }}>
          {typedText}
        </p>
      </div>
      <h2 className="contact-headline reveal-scale">Let's build<br />together</h2>
      <div className="contact-body reveal">
        <div className="contact-cta">
          <button className="contact-email" onClick={handleEmailClick}>
            info@quantena.tech
          </button>
          <span className="contact-email-hint">Click to email · copies to clipboard</span>
        </div>
        <button className="contact-back-to-top" onClick={handleBackToTop}>
          &uarr; Top
        </button>
      </div>
    </section>
  );
}

export default Contact;
